<template>
  <div class="pa-4">
    <v-card outlined class="rounded-lg pa-6">
      <h3 class="mb-4">
        <v-icon right color="primary" class="ml-2">mdi-cart-percent</v-icon>
        تخفیف فروش عمده
      </h3>

      <v-form ref="form" v-model="isValid">
        <div
          v-for="(item, index) in bulkDiscounts"
          :key="index"
          class="d-flex align-start mb-3 gap-3"
        >
          <!-- فیلد ۱: تعداد (حداقل تعداد برای اعمال تخفیف) -->
          <v-text-field
            v-model.number="item.quantity"
            label="تعداد"
            outlined
            dense
            class="rounded-lg flex-grow-1"
            type="number"
            min="1"
            hide-details="auto"
            prepend-inner-icon="mdi-numeric"
            :rules="[
              v => (v !== null && v !== '') || 'تعداد الزامی است',
              v => v > 0 || 'تعداد باید بیشتر از صفر باشد'
            ]"
          />

          <!-- فیلد ۲: درصد تخفیف -->
          <v-text-field
            v-model.number="item.percent"
            label="درصد تخفیف"
            outlined
            dense
            class="rounded-lg flex-grow-1"
            type="number"
            suffix="%"
            step="0.01"
            min="0"
            max="100"
            hide-details="auto"
            prepend-inner-icon="mdi-percent"
            :rules="[
              v => (v !== null && v !== '') || 'درصد تخفیف الزامی است',
              v => (v >= 0 && v <= 100) || 'درصد باید بین ۰ تا ۱۰۰ باشد'
            ]"
          />

          <!-- دکمه‌های عملیات هر  -->
          <div class="d-flex align-center mr-2 mt-1">
            <v-btn icon color="success" @click="addRow(index)" title="افزودن ">
              <v-icon>mdi-plus-circle-outline</v-icon>
            </v-btn>

            <v-btn
              icon
              color="error"
              @click="removeRow(index)"
              :disabled="bulkDiscounts.length === 1"
              title="حذف "
            >
              <v-icon>mdi-trash-can-outline</v-icon>
            </v-btn>
          </div>
        </div>
      </v-form>

      <v-btn class="btn-get-code rounded-lg px-6 mt-8" depressed @click="saveSettings">
        <v-icon left>mdi-content-save</v-icon>
        ذخیره تنظیمات
      </v-btn>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "BulkDiscountTab",
  props: {
  productId: {
    type: [Number, String],
    default: null
  },
  store_id:{
    type:Number,
    default:null
  }
},
  data: () => ({
    isValid: false,
    bulkDiscounts: [
      { quantity: null, percent: null } //  اول به صورت پیش‌فرض
    ]
  }),
  methods: {
    addRow(index) {
      this.bulkDiscounts.splice(index + 1, 0, { quantity: null, percent: null });
    },
    removeRow(index) {
      if (this.bulkDiscounts.length > 1) {
        this.bulkDiscounts.splice(index, 1);
      }
    },
    saveSettings() {
      if (!this.$refs.form.validate()) {
        this.$toast?.error("لطفاً مقادیر خواسته‌شده را به‌درستی وارد کنید.");
        return;
      }

      // مرتب‌سازی بر اساس تعداد (صعودی) قبل از ارسال
      const payload = this.bulkDiscounts
        .map(item => ({
          quantity: Number(item.quantity),
          percent: Number(item.percent)
        }))
        .sort((a, b) => a.quantity - b.quantity);

      console.log("تنظیمات تخفیف عمده:", payload);
      this.$toast?.success("تنظیمات تخفیف عمده با موفقیت ذخیره شد");
    }
  }
};
</script>

<style scoped>
.gap-3 {
  gap: 12px;
}
</style>
